module.exports = __webpack_public_path__ + "img/portada2.71a0f00b.png";